import React from 'react';
import {
    ActivityIndicator,
    FlatList,
    Image,
    KeyboardAvoidingView,
    Platform,
    ScrollView,
    Switch,
    Text,
    TextInput,
    TouchableOpacity,
    View
} from 'react-native';
import {connect} from 'react-redux';
import IAppState from "../Models/App/IAppState";

import {AnyAction} from "redux";
import AppText from "../Components/AppText";
import HideableView from "../Components/HideableView";
import {DrawerNavigationProp} from "@react-navigation/drawer";
import RNPickerSelect from 'react-native-picker-select';
import {AntDesign as Icon} from '@react-native-vector-icons/ant-design/static';
import IClient from "../Models/Client/IClient";
import ISubClient from "../Models/Client/ISubClient";
import IOrder from "../Models/IOrder";
import ISubOrder from "../Models/Courier/ISubOrder";
import ICourier from "../Models/Courier/ICourier";
import SubOrderItem from "../Components/SubOrderItem";
import AppButton from "../Components/AppButton";
import HttpRequest from "../utils/HttpRequest";
import AlertModal from "../Components/AlertModal";
import DateTimePickerModal from "../Components/DateTimePickerModal";
import {saveCouriers} from "../Models/Courier/CourierActions";
import {saveClients} from "../Models/Client/ClientActions";
import IUser from "../Models/User/IUser";
import {EUserType} from "../Models/User/EUserType";
import ClientsSelectionModal from "../Components/ClientsSelectionModal";
import SubClientsSelectionModal from "../Components/SubClientsSelectionModal";

type navProps = DrawerNavigationProp< any, 'Clients'>;
interface IProps {
    navigation:navProps;
    clients:IClient[]
    couriers:ICourier[]
    saveCouriers:(couriers:ICourier[])=>AnyAction
    saveClients:(clients:IClient[])=>AnyAction
    user?:IUser

}
interface IState {
    isAddOpened:boolean;
    selectedClient?:IClient
    selectedSubClient?:ISubClient
    order:IOrder,
    subOrder:ISubOrder,
    isLoading:boolean;
    showAlert:boolean;
    alertText:string;
    isErrorAlert:boolean;
    isDateModalShowing:boolean;
    isTimeModalShowing:boolean;
    fetching:boolean;
    isScrollDisabled:boolean
    subClientsIds:number[]
    isNewSubClient:boolean;
    lastId:number;
    showSelection:boolean;
    showSubClientSelection:boolean;
}

class OpenOrder extends React.Component<IProps> {

    state:IState={
        showAlert:false,
        isErrorAlert:false,
        alertText:'',
        isAddOpened:false,
        isLoading:false,
        isDateModalShowing:false,
        isTimeModalShowing:false,
        order:{ClientId:-1,SubOrders:[],isDeleted:false},
        fetching:false,
        isScrollDisabled:false,
        subClientsIds:[],
        subOrder:{SubClientId:-1,CourierId:-1,notes:'',isRegular:true,isExpress:false,isCar:false,isMsg:false,isOutSide:false,isPackage:false,status:0,orderDate:new Date().toISOString(),orderTime:new Date().getHours()+":"+new Date().getMinutes(),type:0,isDeleted:false},
        isNewSubClient:false,
        lastId:0,
        showSelection:false,
        showSubClientSelection:false
    }
    focusListiner:any=null;
    componentDidMount() {

        this.focusListiner= this.props.navigation.addListener('focus',this.getData)
    }
    getData=()=>{
        if(this.props.couriers.length==0 ){
            this.fetchCouriers()
        }
        if(this.props.clients.length==0){
            this.fetchClients();
        }
        //this.getCourier()
    }
    componentWillUnmount() {
        if(this.focusListiner){
            this.focusListiner()
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {

    }

    fetchCouriers(){
        this.setState({fetching:true})
        HttpRequest('couriers',"GET").then((result)=>{
            this.props.saveCouriers(result.data);
            this.setState({couriers:result.data})
        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    fetchClients(){
        this.setState({fetching:true})
        HttpRequest('clients',"GET").then((result)=>{
            this.props.saveClients(result.data)
            this.setState({clients:result.data})

        }).catch(e=>{

        }).finally(()=>this.setState({fetching:false}))
    }
    selectClient(id:number){
        this.setState({showSelection:false})
        let client=this.props.clients.filter(c=>c.id==id)[0];
        if(!client){
            let order=this.state.order;
            order.ClientId=-1;
            order.SubOrders=[]
            this.setState({selectedClient:undefined,order:order,selectedSubClient:undefined})
            return;
        }

        let order=this.state.order;
        order.ClientId=client.id?client.id:-1;
        let subs=client.SubClients?client.SubClients:[];
        for(let i=0;i<subs.length;i++){
            subs[i].isSelected=false;
        }
        client.SubClients=subs;
        order.SubOrders=[]
        this.setState({order:order})
        this.setState({selectedClient:client,selectedSubClient:undefined});
        if(this.props.user && this.props.user.type==EUserType.courier && this.props.user.CourierId){
            this.setCourier(this.props.user.CourierId)
            return;
        }
        this.setCourier(8)
    }
    selectSubClient(id:number){
        if(this.state.selectedClient && this.state.selectedClient.SubClients){
            let client=this.state.selectedClient;
            let subs=this.state.selectedClient.SubClients

            for(let i=0;i<subs.length;i++){
                if(subs[i].id==id){
                    subs[i].isSelected=!subs[i].isSelected;
                }
            }
            client.SubClients=subs;
            this.setState({selectedClient:client})

            //let subOrder=this.state.subOrder;
            //subOrder.SubClient=client;
            //subOrder.SubClientId=client.id?client.id:-1;
            //this.setState({selectedSubClient:client})
        }

    }
    getSelectedSubClients(){
        if(this.state.selectedClient && this.state.selectedClient.SubClients){
            let subs=this.state.selectedClient.SubClients
            subs=subs.filter(s=>s.isSelected);
            return subs.map(s=>s.name).join(", ")
        }
        return "";
    }
    setDate(date:Date){
        let subOrder=this.state.subOrder;
        subOrder.orderDate=date.toISOString();
        this.setState({subOrder:subOrder,isDateModalShowing:false})
    }
    setTime(date:Date){
        let time=date.getHours()+":"+date.getMinutes();
        let subOrder=this.state.subOrder;
        subOrder.orderTime=time;
        this.setState({subOrder:subOrder,isTimeModalShowing:false})
    }
    setCourier(id:number){

        let courier=this.props.couriers.filter(c=>c.id==id)[0];
        if(courier){
            this.setSubOrderProp(courier,"Courier")
            this.setSubOrderProp(courier.id,"CourierId")
        }
    }
    setSubOrderProp<K extends keyof ISubOrder>(value:any,key:K){
        let subOrder=this.state.subOrder;
        subOrder[key]=value;
        this.setState({subOrder:subOrder})

    }
    addSubOrder(){
        let subOrder=this.state.subOrder;

        if(subOrder.CourierId==-1){
            this.setState({showAlert:true,alertText:'נא לבחור שליח',isErrorAlert:true})
            return;
        }

        let order=this.state.order;
        let cnt=0;
        if(order.SubOrders.length>0){
            if(order.SubOrders && order.SubOrders[order.SubOrders.length-1] && order.SubOrders[order.SubOrders.length-1].id){
                let id=order.SubOrders[order.SubOrders.length-1].id
                // @ts-ignore
                lastId=id+1;
            }

        }
        let lastId=this.state.lastId;
        lastId=lastId+1;
        if(this.state.isNewSubClient){
            let subClient=this.state.selectedSubClient;
            if(subClient && subClient.name ){
                subClient.isNew=true;
                subOrder.SubClient=subClient;
                subOrder.id=lastId;
                order.SubOrders.push(subOrder)
                let courier=subOrder.Courier;
                this.setState({order:order,selectedSubClient:undefined,subOrder:{SubClientId:-1,CourierId:courier?.id,Courier:courier,isRegular:true,isExpress:false,isCar:false,isMsg:false,isOutSide:false,isPackage:false,status:0,orderDate:'',orderTime:''}})

                return;
            }
            this.setState({showAlert:true,alertText:'נא למלא את שם לקוח משנה',isErrorAlert:true})
            return;
        }
        if(this.state.selectedClient && this.state.selectedClient.SubClients){
            let subs=this.state.selectedClient.SubClients;
            for(let i=0;i<subs.length;i++){
                let newSubOrder:ISubOrder={SubClientId:-1,CourierId:subOrder.CourierId,notes:subOrder.notes,isRegular:subOrder.isRegular,isExpress:subOrder.isExpress,isCar:subOrder.isCar,isMsg:subOrder.isMsg,isOutSide:subOrder.isOutSide,isPackage:subOrder.isPackage,status:0,orderDate:subOrder.orderDate,orderTime:subOrder.orderTime,type:subOrder.type,isDeleted:false}
                if(subs[i].isSelected){
                    cnt++;
                    console.log(subs[i].name)
                    let id=0;
                    if(subs[i].id && subs[i].id!=undefined){
                        // @ts-ignore
                        id=subs[i].id;
                    }
                    newSubOrder.CourierId=subOrder.CourierId;
                    newSubOrder.Courier=subOrder.Courier;
                    newSubOrder.id=lastId;
                    newSubOrder.SubClientId=id;
                    newSubOrder.SubClient=subs[i];
                    lastId=lastId+1;
                    order.SubOrders.push(newSubOrder);
                }
            }
            for(let i=0;i<subs.length;i++){
                subs[i].isSelected=false;
            }
            let selectedClient=this.state.selectedClient;
            selectedClient.SubClients=subs;
            this.setState({selectedClient:selectedClient})
        }
        if(cnt==0){
            this.setState({showAlert:true,alertText:'נא לבחור לקוח משנה',isErrorAlert:true})
            return;
        }

        let courier=subOrder.Courier;
        this.setState({order:order,lastId:lastId,selectedSubClient:undefined,subOrder:{SubClientId:-1,CourierId:courier?.id,Courier:courier,isRegular:true,isExpress:false,isCar:false,isMsg:false,isOutSide:false,isPackage:false,status:0,orderDate:new Date().toDateString().substring(0,10),orderTime:new Date().getHours()+":"+new Date().getMinutes(),type:0}})
        this.setState({showAlert:true,alertText:'לקוחות נוספו להזמנה בהצלחה,'+"\n"+"נא לשמור את ההזמנה במערכת",isErrorAlert:false})
        /*if(courier){
            this.setSubOrderProp(courier,"Courier")
            this.setSubOrderProp(courier.id,"CourierId")
        }*/

    }
    saveOrder(sendMail:boolean = false){


        let order=this.state.order;
        if(order.SubOrders.length==0){
            this.setState({showAlert:true,alertText:'נא להוסיף לקוח משנה',isErrorAlert:true})
            return
        }
        this.setState({isLoading:true})
        order.SubOrders.forEach(x=>x.id=undefined);
        let clientMail = null;
        if(sendMail){
            clientMail = this.state.selectedClient?.email
        }
        HttpRequest('orders',"POST",{order:order,clientMail:clientMail}).then((result)=>{
            let order=this.state.order;
            order.ClientId=-1;
            order.SubOrders=[]
            this.setState({
                selectedClient:undefined,
                selectedSubClient:undefined,
                showAlert:false,
                isErrorAlert:false,
                alertText:'',
                isAddOpened:false,
                isLoading:false,
                isDateModalShowing:false,
                isTimeModalShowing:false,
                order:{ClientId:-1,SubOrders:[],isDeleted:false},
                fetching:false,
                isScrollDisabled:false,
                subClientsIds:[],
                subOrder:{SubClientId:-1,CourierId:-1,notes:'',isRegular:true,isExpress:false,isCar:false,isMsg:false,isOutSide:false,isPackage:false,status:0,orderDate:new Date().toISOString(),orderTime:new Date().getHours()+":"+new Date().getMinutes(),type:0,isDeleted:false},
                isNewSubClient:false,
                lastId:0
            })
            this.setState({showAlert:true,alertText:'הזמנה נשמרה בהצלחה',isErrorAlert:false})

        }).catch(e=>{
            //Alert.alert(JSON.stringify(e))
            this.setState({showAlert:true,alertText:'שגיאת רשת אנא נסה שוב',isErrorAlert:true})
        }).finally(()=>{
            this.setState({isLoading:false})
        })
    }
    removeSubOrder(subOrder:ISubOrder){
        let order=this.state.order;
        let subOrders=order.SubOrders;
        subOrders=subOrders.filter(s=>s.id!=subOrder.id);
        order.SubOrders=subOrders;
        this.setState({order:order})
    }
    closeDateTimeModal(){
        this.setState({isTimeModalShowing:false,isDateModalShowing:false})
    }
    setSubClientProp<K extends keyof ISubClient>(value:any,key:K){
        let subClient=this.state.selectedSubClient;
        if(this.state.selectedClient){
            let id=this.state.selectedClient.id?this.state.selectedClient.id:0;
            if(!subClient){
                subClient={name:'',address:'',phone:'',ClientId:id,}
            }
            subClient[key]=value;
            this.setState({selectedSubClient:subClient})
        }

    }
    getCourier(){
        //this.state.subOrder?this.state.subOrder.CourierId:-1
        if(this.props.user && this.props.user.type==EUserType.courier){
            if(this.props.user.CourierId && this.state.subOrder.Courier?.id!=this.props.user.CourierId){
                this.setCourier(this.props.user.CourierId)
            }

            return this.props.user.CourierId
        }
        if(this.state.subOrder.Courier?.id!=8){
            this.setCourier(8)
        }

        return 8;
    }
    showClientSelection(){
        this.setState({showSelection:true})
    }
    setClientMail(text:string){
        if(this.state.selectedClient){
            const client = this.state.selectedClient;
            client.email = text;
            this.setState({selectedClient:client})
        }
    }
    render() {
        const selectedSubClientsStr=this.getSelectedSubClients();
        return(
            !this.state.fetching?  <KeyboardAvoidingView behavior={Platform.OS == "ios" ? "padding" : "height"} style={{width:'100%',flex:1,backgroundColor:'white',position:'relative'}}>
                    <ScrollView  scrollEnabled={!this.state.isScrollDisabled} keyboardShouldPersistTaps="handled" style={{display:'flex',flexDirection:'column',position:'relative',backgroundColor:'white',flex:1,width:'100%',marginBottom:50}}>
                        <View style={{paddingLeft:15,paddingRight:15,backgroundColor:'#F6F6F6',paddingTop:5,paddingBottom:15}}>
                            <AppText style={{textAlign:'left',fontSize:16,fontWeight:'500'}}>פרטי הזמנה</AppText>
                            <View style={{width:'100%',alignItems:'center',zIndex:100}}>
                                {
                                    /*
                                     <FilterableInput openCallBack={(isOpened:boolean)=>this.setState({isScrollDisabled:isOpened})} onValueChange={(val:number)=>this.selectClient(val)} width={'85%'} placeholder={'שם המזמין'} options={this.props.clients.map(c=>{
                                    return {label:c.businessName,value:c.id}
                                })}/>
                                    */
                                }

                                <TouchableOpacity style={{width:'85%',height:30,justifyContent:'center',alignItems:'flex-start',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,paddingLeft:10,paddingRight:10,marginTop:5}} onPress={()=>this.showClientSelection()}>
                                    <AppText style={{fontSize:13,color:this.state.selectedClient ?'black':'grey'}}>{this.state.selectedClient ? (this.state.selectedClient.businessName +" | "+this.state.selectedClient.address) :"שם המזמין"}</AppText>
                                </TouchableOpacity>
                                <View style={{width:'85%',flexDirection:'row',justifyContent:'space-between'}}>
                                    <TextInput placeholderTextColor={'#989898'} value={this.state.selectedClient?.contactName} style={{height:30,paddingTop:1,paddingBottom:1,width:'49%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'איש קשר'}/>
                                    <TextInput placeholderTextColor={'#989898'} value={this.state.selectedClient?.phone} style={{height:30,paddingTop:1,paddingBottom:1,width:'49%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'טלפון'}/>
                                </View>
                                <TextInput placeholderTextColor={'#989898'} onChangeText={(text) => this.setClientMail(text)} value={this.state.selectedClient?.email} style={{height:30,paddingTop:1,paddingBottom:1,width:'85%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'מייל'}/>
                            </View>
                        </View>
                        <HideableView hidden={!this.state.selectedClient} style={{paddingLeft:15,paddingRight:15,backgroundColor:'#01B271',paddingTop:5,paddingBottom:15,zIndex:1, elevation: 1}}>
                            <AppText style={{textAlign:'left',fontSize:16,fontWeight:'500',color:'#fff'}}>לקוחות משנה</AppText>
                            <View style={{width:'100%',alignItems:'center'}}>
                                <View style={{flexDirection:'row',width:'85%',paddingLeft:15,alignSelf:'center',marginTop:10,justifyContent:'flex-start',alignItems:'center'}}>
                                    <Switch  trackColor={{ false: "white", true: "#767577" }}
                                             thumbColor={ "#f4f3f4"}
                                             value={this.state.isNewSubClient}
                                             onValueChange={value => {

                                                 this.setState({isNewSubClient:!this.state.isNewSubClient,isScrollDisabled:false})
                                             }}
                                    />
                                    <Text style={{marginLeft:10,fontSize:16,color:'white'}}>{"תת לקוח חדש"}</Text>
                                </View>
                                <View style={{width:'85%',flexDirection:'row',justifyContent:'space-between',zIndex:100,elevation:2}}>
                                    <HideableView style={{width:'49%',elevation:2}} hidden={this.state.isNewSubClient}>
                                        {
                                            /*
                                            <MultiFilterableInput  openCallBack={(isOpened:boolean)=>this.setState({isScrollDisabled:isOpened,isSelectSubClientOpened:isOpened})} onValueChange={(val:number)=>this.selectSubClient(val)} width={'100%'} placeholder={'שם המזמין'} options={this.state.selectedClient&&this.state.selectedClient.SubClients?this.state.selectedClient.SubClients.map(c=>{
                                            return {label:c.name,value:c.id,isSelected:c.isSelected}
                                        }):[]}/>
                                            */
                                            <TouchableOpacity style={{width:'100%',height:30,justifyContent:'center',alignItems:'flex-start',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,paddingLeft:10,paddingRight:10,marginTop:5}} onPress={()=>this.setState({showSubClientSelection:true})}>
                                                <AppText style={{fontSize:13,color:selectedSubClientsStr ?'black':'grey'}} numberOfLines={1}>{selectedSubClientsStr ? selectedSubClientsStr:"תת לקוח"}</AppText>
                                            </TouchableOpacity>
                                        }
                                    </HideableView>
                                    <HideableView style={{width:'49%'}} hidden={!this.state.isNewSubClient}>
                                        <TextInput onChangeText={(text)=>this.setSubClientProp(text,"name")} placeholderTextColor={'#989898'} value={this.state.selectedSubClient?.name} style={{height:30,width:'100%',paddingTop:1,paddingBottom:1,backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'שם המזמין'}/>

                                    </HideableView>
                                    <TextInput placeholderTextColor={'#989898'} onChangeText={(text)=>{
                                        if(this.state.isNewSubClient){
                                            this.setSubClientProp(text,"phone")
                                        }
                                    }} value={this.state.selectedSubClient?.phone} style={{height:30,paddingTop:1,paddingBottom:1,width:'49%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'טלפון'}/>

                                </View>
                                <TextInput onChangeText={(text)=>{
                                    if(this.state.isNewSubClient){
                                        this.setSubClientProp(text,"address")
                                    }
                                }} placeholderTextColor={'#989898'} value={this.state.selectedSubClient?.address} style={{height:30,paddingTop:1,paddingBottom:1,width:'85%',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'כתובת'}/>

                                <View style={{width:'85%',flexDirection:'row',justifyContent:'space-between'}}>
                                    <TouchableOpacity disabled={this.state.isScrollDisabled} style={{width:'49%',height:30,justifyContent:'center',alignItems:'flex-start',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,paddingLeft:10,paddingRight:10,marginTop:5}} onPress={()=>{
                                        this.setState({isDateModalShowing:true})

                                    }}>
                                        <AppText style={{fontSize:13,color:this.state.subOrder.orderTime==""?'grey':'black'}}>{this.state.subOrder.orderDate==""?"תאריך":this.state.subOrder.orderDate.substring(0,10)}</AppText>
                                    </TouchableOpacity>
                                    <TouchableOpacity disabled={this.state.isScrollDisabled} style={{width:'49%',height:30,justifyContent:'center',alignItems:'flex-start',backgroundColor:'white',borderRadius:25,borderColor:'grey',borderWidth:1,paddingLeft:10,paddingRight:10,marginTop:5}} onPress={()=>this.setState({isTimeModalShowing:true})}>
                                        <AppText style={{fontSize:13,color:this.state.subOrder.orderTime==""?'grey':'black'}}>{this.state.subOrder.orderTime==""?"שעה":this.state.subOrder.orderTime}</AppText>
                                    </TouchableOpacity>

                                </View>
                                <View style={{width:'100%',justifyContent:'center',alignItems:'center'}}>
                                    <TextInput editable={!this.state.isScrollDisabled} placeholderTextColor={'#989898'} onChangeText={(text)=>this.setSubOrderProp(text,"notes")} value={this.state.subOrder.notes} multiline={true} style={{height:70,paddingTop:1,paddingBottom:1,width:'85%',backgroundColor:'white',borderRadius:15,borderColor:'grey',borderWidth:1,textAlign:'right',paddingLeft:10,paddingRight:10,marginTop:5}} placeholder={'הערות'}/>

                                </View>
                                <View style={{flexDirection:'row',justifyContent:'center',width:'80%',marginTop:10}}>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isRegular,"isRegular")} >
                                        <Image source={require('../assets/regular.png')} style={{width:80,height:80,borderColor:'white',borderWidth:this.state.subOrder.isRegular?3:0}} />
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isPackage,"isPackage")} >
                                        <Image source={require('../assets/package.png')} style={{width:80,height:80,marginLeft:5,marginRight:5,borderColor:'white',borderWidth:this.state.subOrder.isPackage?3:0}} />
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isMsg,"isMsg")} >
                                        <Image source={require('../assets/mail.png')} style={{width:80,height:80,borderColor:'white',borderWidth:this.state.subOrder.isMsg?3:0}} />
                                    </TouchableOpacity>
                                </View>
                                <View style={{flexDirection:'row',justifyContent:'center',width:'80%',marginTop:5}}>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isOutSide,"isOutSide")} >
                                        <Image source={require('../assets/outSide.png')} style={{width:80,height:80,borderColor:'white',borderWidth:this.state.subOrder.isOutSide?3:0}} />
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isCar,"isCar")} >
                                        <Image source={require('../assets/car.png')} style={{width:80,height:80,marginLeft:5,marginRight:5,borderColor:'white',borderWidth:this.state.subOrder.isCar?3:0}} />
                                    </TouchableOpacity>
                                    <TouchableOpacity onPress={()=>this.setSubOrderProp(!this.state.subOrder.isExpress,"isExpress")} >
                                        <Image source={require('../assets/express.png')} style={{width:80,height:80,borderColor:'white',borderWidth:this.state.subOrder.isExpress?3:0}} />
                                    </TouchableOpacity>
                                </View>
                                <View style={{flexDirection:'row',width:'80%',paddingLeft:15,alignSelf:'center',marginTop:10,justifyContent:'flex-start',alignItems:'center'}}>
                                    <Switch  trackColor={{ false: "white", true: "#767577" }}
                                             thumbColor={this.state.subOrder.type==0 ? "#019FB2" : "#f4f3f4"}
                                             value={this.state.subOrder.type==0?true:false}
                                             onValueChange={value => {
                                                 let subOrder=this.state.subOrder
                                                 if(subOrder.type==1){
                                                     subOrder.type=0;
                                                 }
                                                 else if(subOrder.type==0){
                                                     subOrder.type=1;
                                                 }
                                                 this.setState({subOrder:subOrder})
                                             }}
                                    />
                                    <Text style={{marginLeft:10,fontSize:16,color:'white'}}>{this.state.subOrder.type==0?'איסוף':'פיזור'}</Text>
                                </View>



                            </View>
                            <View style={{paddingTop:5}}>
                                <AppText style={{textAlign:'left',color:'#fff',fontSize:16,fontWeight:'500'}}>שיוך לשליח</AppText>
                                <View style={{width:'85%',height:30,alignSelf:'center',backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginTop:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                                    <View style={{flex:0.8,justifyContent:'center'}}>
                                        <RNPickerSelect

                                            onValueChange={(value) => this.setCourier(value)}
                                            value={this.state.subOrder.CourierId}
                                            placeholder={{ label: 'שם השליח', value: 'שם השליח' }}
                                            style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                            items={this.props.couriers.map(c=>{
                                                return {label:c.name,value:c.id}
                                            })}
                                        />
                                    </View>
                                    <View style={{flex:0.2,justifyContent:'center'}}>
                                        <Icon name="down" size={15} color="#000" />
                                    </View>

                                </View>
                                <TouchableOpacity onPress={()=>this.addSubOrder()} style={{width:125,height:30,backgroundColor:'#373737',marginLeft:10,alignSelf:'center',marginTop:10,justifyContent:'center',alignItems:'center',borderRadius:25}}>
                                    <AppText style={{color:'#fff',fontWeight:'700'}}>הוסף לקוח משנה</AppText>
                                </TouchableOpacity>
                            </View>
                        </HideableView>
                        <HideableView hidden={!this.state.selectedClient}>
                            <View style={{marginTop:10,marginBottom:5,width:'100%',justifyContent:'center',alignItems:'center'}}>
                                <AppButton width={125} text={'שמור הזמנה'} isLoading={this.state.isLoading} onPress={()=>this.saveOrder()} color={'#01B271'}/>
                            </View>
                            <View style={{marginTop:5,marginBottom:10,width:'100%',justifyContent:'center',alignItems:'center'}}>
                                <AppButton width={200} text={'שמור הזמנה ושלח מייל'} isLoading={this.state.isLoading} onPress={()=>this.saveOrder(true)} color={'#01B271'}/>
                            </View>
                            <FlatList
                                data={this.state.order.SubOrders}
                                ListHeaderComponent={()=><View style={{height:30,width:'100%',backgroundColor:'#373737',paddingLeft:15,paddingRight:15,flexDirection:'row',alignItems:'center'}}>
                                    <View style={{flex:0.23,alignItems:'flex-start'}}>
                                        <AppText style={{color:'white'}}>שם</AppText>
                                    </View>
                                    <View style={{flex:0.34,alignItems:'flex-start'}}>
                                        <AppText style={{color:'white'}}>כתובת</AppText>
                                    </View>
                                    <View style={{flex:0.23,alignItems:'flex-start'}}>
                                        <AppText style={{color:'white'}}>טלפון</AppText>
                                    </View>
                                    <View style={{flex:0.2,alignItems:'flex-start'}}>

                                    </View>
                                </View>}
                                renderItem={({ item }) =><SubOrderItem order={this.state.order} openingMode={true} subOrder={item} removeCallBack={(subOrder:ISubOrder)=>this.removeSubOrder(subOrder)}/> }
                            />
                        </HideableView>

                        <AlertModal isError={this.state.isErrorAlert} show={this.state.showAlert} text={this.state.alertText} closeCallBack={()=>this.setState({showAlert:false})}/>
                        <DateTimePickerModal closeCallBack={()=>this.closeDateTimeModal()} onChange={(val:any)=>this.state.isTimeModalShowing?this.setTime(val):this.setDate(val)} mode={this.state.isTimeModalShowing?"time":'date'} show={this.state.isDateModalShowing==true || this.state.isTimeModalShowing==true?true:false} />
                    </ScrollView>

                <ClientsSelectionModal show={this.state.showSelection } onChange={(id:number)=>this.selectClient(id)} data={this.props.clients} onClose={()=>this.setState({showSelection:false})}/>
                <SubClientsSelectionModal show={this.state.showSubClientSelection } onChange={(id:number)=>this.selectSubClient(id)} data={this.state.selectedClient&&this.state.selectedClient.SubClients?this.state.selectedClient.SubClients:[]} onClose={()=>this.setState({showSubClientSelection:false})}/>

            </KeyboardAvoidingView>:<View style={{flex:1,backgroundColor:'white',justifyContent:'center',alignItems:'center'}}>
                <ActivityIndicator size={"large"} color={'#019FB2'} />

            </View>

        );
    }
}
const mapStateToProps = (state:IAppState) => {
    //Alert.alert(JSON.stringify(state))
    return {
        clients:state.client.clients,
        couriers:state.courier.couriers,
        user:state.user.current,
    };
};

const mapDispatchToProps ={
    saveCouriers:saveCouriers,
    saveClients:saveClients

};

export default connect(mapStateToProps, mapDispatchToProps)(OpenOrder);
/*


     <View style={{width:'85%',height:30,backgroundColor:'white',flexDirection:'row',borderRadius:25,borderColor:'grey',borderWidth:1,marginTop:5,justifyContent:'space-between',paddingLeft:10,paddingRight:10}}>
                                <View style={{flex:0.8,justifyContent:'center'}}>
                                    <RNPickerSelect
                                        onValueChange={(value) =>this.selectClient(value)}
                                        placeholder={{ label: 'שם המזמין', value: 'שם המזמין' }}
                                        style={{inputIOS:{width:'100%',height:25,alignSelf:'center',textAlign:'right'}}}
                                        items={this.props.clients.map(c=>{
                                            return {label:c.businessName,value:c.id}
                                        })}
                                        useNativeAndroidPickerStyle={false}
                                    />
                                </View>
                                <View style={{flex:0.2,justifyContent:'center'}}>
                                    <Icon name="down" size={15} color="#000" />
                                </View>

                            </View>
 */
